import React, {Component} from 'react';
import Head from '../common/Head'
import HowInfo from './HowInfoPane';
import GetStarted from './getStartedPane';
import WorksFor from './worksForPane';
import HomeRegister from './HomeRegister';
import HomeAbout from './HomeAbout';

export default class HomePage extends Component {
  render () {
    return (
			<div>
				<Head/>
				<div className="container">
					<HomeAbout/>
					<div className="how-info">
						<HowInfo/>
					</div>
					<GetStarted/>
					<WorksFor/>
				</div>
				<HomeRegister />
			</div>
    );
  }
}




// WEBPACK FOOTER //
// ./src/components/home/HomePage.js